import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface CategoryTabsProps {
  categories: { name: string; slug: string; icon: string }[];
  activeSlug: string;
  basePath?: string;
}

export default function CategoryTabs({ categories, activeSlug, basePath = '/category' }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {categories.map((cat) => {
        const isActive = cat.slug === activeSlug;
        const href = cat.slug === 'all' ? '/' : `${basePath}/${cat.slug}`;
        return (
          <Link
            key={cat.slug}
            to={href}
            className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
              isActive
                ? 'bg-accent-500 text-white'
                : 'bg-background-100 text-foreground-600 hover:text-accent-500 hover:bg-background-200 border border-background-200/50'
            }`}
          >
            <i className={`${cat.icon} text-sm`}></i>
            {cat.name}
          </Link>
        );
      })}
    </div>
  );
}